if (!customElements.get("ops-undercover-agents")) {
	customElements.define(
		"ops-undercover-agents",
		class OpsUndercoverAgents extends HTMLElement {
			classItemIsActive = "opsUndercoverAgentsItem--isActive";
			classBlurbIsActive = "opsUndercoverAgentsBlurb--isActive";

			connectedCallback() {
				this.elements = {
					prev: this.querySelector(".opsUndercoverAgents-prev"),
					next: this.querySelector(".opsUndercoverAgents-next"),
					items: this.querySelector(".opsUndercoverAgents-items"),
					itemList: this.querySelectorAll(".opsUndercoverAgentsItem"),
					progress: this.querySelector(".opsUndercoverAgents-progress"),
					progressIndicator: this.querySelector(".opsUndercoverAgents-progressIndicator"),
				};

				this.indexActive = 0;
				this.visibleThreshold = 3;
				this.itemsLength = Math.max(1, this.elements.itemList.length);
				this.progressStep = (1 / this.itemsLength) * 100;

				ops.onTap(this.elements.prev, (event) => this.onPrev(event));
				ops.onTap(this.elements.next, (event) => this.onNext(event));
				ops.onTap(this.elements.progress, (event) => this.onProgress(event));
				ops.onSwipe(this.elements.items, (isLeft, isRight) => {
					isLeft && this.onNext();
					isRight && this.onPrev();
				});

				this.elements.itemList.forEach((item, index) => {
					// console.log("OpsUndercoverAgents.connectedCallback", { item, index });
					ops.onTap(item, () => this.setIndexActive(index));
				});

				this.setProgressIndicatorWidth();
				this.setIndexActive(0);

				window.addEventListener("resize", ops.throttle(this.onResize.bind(this), 10));
				window.addEventListener("load", this.onResize.bind(this));
			}

			disconnectedCallback() {
				// TODO: reidenzon - Something interesting!
			}

			onPrev() {
				this.setIndexActive(this.indexActive - 1);
			}

			onNext() {
				this.setIndexActive(this.indexActive + 1);
			}

			onProgress(event) {
				const rBar = this.elements.progress.getBoundingClientRect();
				const left = event.clientX - rBar.left;
				const index = Math.floor((left / rBar.width) * this.itemsLength);
				// console.log("OpsHomeContainers.onProgressClick", index, event.clientX, rBar);
				this.setIndexActive(index);
			}

			onResize() {
				this.setIndexActive(this.indexActive);
			}

			setIndexActive(indexNew) {
				// console.log("OpsUndercoverAgents.setIndexActive", indexNew);
				this.indexActive = indexNew;
				const rItems = this.elements.items.getBoundingClientRect();

				if (indexNew < 0) {
					this.setIndexActive(indexNew + this.itemsLength);
					return;
				}
				if (indexNew >= this.itemsLength) {
					this.setIndexActive(indexNew - this.itemsLength);
					return;
				}

				this.elements.itemList.forEach((item, index) => {
					const itemImage = item.querySelector(".opsUndercoverAgentsItem-image");
					const itemScale = item.querySelector(".opsUndercoverAgentsItem-image-scale");

					let activeOffset = index - this.indexActive;
					if (Math.abs(activeOffset) >= this.visibleThreshold + 1) {
						activeOffset += activeOffset < 0 ? this.itemsLength : -this.itemsLength;
					}

					// const rItem = item.getBoundingClientRect();
					const rImage = itemImage.getBoundingClientRect();

					const dir = activeOffset >= 0 ? 1 : -1;
					const frac = Math.abs(Math.min(1, Math.max(-1, activeOffset / this.visibleThreshold)));

					const delta = frac * 0.4;
					const deltaAbs = Math.abs(delta);

					const isVisible = Math.abs(activeOffset) <= this.visibleThreshold;

					const brightness = 1 - deltaAbs;
					itemScale.style.filter = `grayscale(1) brightness(${brightness})`;

					const opacity = isVisible ? 1 : 0;
					item.style.opacity = opacity * 100 + "%";

					const scale = 1 - deltaAbs;
					itemScale.style.scale = scale * 100 + "%";

					const left = rItems.width / 2 + dir * (Math.pow(frac, 0.8) * (rItems.width / 2 - rImage.width / 2) + (rImage.width * (1 - scale)) / 2);
					item.style.left = left + "px";

					const zIndex = this.visibleThreshold - Math.abs(activeOffset);
					item.style.zIndex = zIndex + "";

					const isActive = activeOffset === 0;
					isActive && item.classList.add(this.classItemIsActive);
					!isActive && item.classList.remove(this.classItemIsActive);
				});

				this.elements.progressIndicator.style.left = this.indexActive * this.progressStep + "%";
			}

			setProgressIndicatorWidth() {
				this.elements.progressIndicator.style.width = this.progressStep + "%";
			}
		},
	);
}
